import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";

export const TYPE_LABEL = { aset: "Aset", liabilitas: "Liabilitas", ekuitas: "Ekuitas", pendapatan: "Pendapatan", beban: "Beban" };

export const useAccounts = () => {
  const [accounts, setAccounts] = useState([]);
  const reload = () => api.get("/admin/finance/accounts").then((r) => setAccounts(r.data));
  useEffect(() => { reload(); }, []);
  return [accounts, reload];
};

export const accName = (accounts, code) => accounts.find((a) => a.code === code)?.name || code;

export const AccountSelect = ({ accounts, value, onChange, testid, placeholder = "Pilih akun", common = [], grouped = true }) => {
  const active = accounts.filter((a) => a.active);
  const top = common.map((c) => active.find((a) => a.code === c)).filter(Boolean).slice(0, 4);
  const types = [...new Set(active.map((a) => a.type))];
  return (
    <Select value={value || ""} onValueChange={onChange}>
      <SelectTrigger className="h-12 text-base" data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent className="max-h-80">
        {top.length > 0 && (
          <SelectGroup>
            <SelectLabel>Sering dipakai</SelectLabel>
            {top.map((a) => <SelectItem key={`top-${a.code}`} value={a.code}>{a.name}</SelectItem>)}
          </SelectGroup>
        )}
        {grouped ? types.map((t) => (
          <SelectGroup key={t}>
            <SelectLabel>{TYPE_LABEL[t]}</SelectLabel>
            {active.filter((a) => a.type === t && !top.includes(a)).map((a) => <SelectItem key={a.code} value={a.code}>{a.code} · {a.name}</SelectItem>)}
          </SelectGroup>
        )) : active.filter((a) => !top.includes(a)).map((a) => <SelectItem key={a.code} value={a.code}>{a.name}</SelectItem>)}
      </SelectContent>
    </Select>
  );
};
